import { styles } from "./moduleTime.css";

/**
 * Displays the workshop module's duration.
 *
 * @param {Object} props - The props object.
 * @param {number} [props.duration] - Specifies the length of the module (station or procedure)
 * @returns {JSX.Element} A JSX element representing the time pill.
 */
export const ModuleTime = ({ duration }) => {
  if (!duration) return <div style={{ width: "76px" }} />;
  return (
    <div className={styles.moduleTime}>
      <div>{duration} min</div>
    </div>
  );
};
